 
 
 
 
 
 
/**
 * @ignore
 * A clickable button with associated text, icon and click event handler.
 */
define(['leaflet', './../simpleSVGIcon'], function(L, simpleSVGIcon) {
    'use strict';
    var classes = {
        action: 'tomtom-point-content__action',
        icon: 'tomtom-point-content__icon',
        text: 'tomtom-point-content__text'
    };

    return function(icon, text, clickHandler) {
        var buttonContainer = L.DomUtil.create('div', classes.action),
            iconContainer = L.DomUtil.create('div', classes.icon, buttonContainer),
            textContainer = L.DomUtil.create('span', classes.text, buttonContainer);

        if (icon) {
            iconContainer.appendChild(simpleSVGIcon(icon));
        }

        textContainer.innerHTML = text;

        if (clickHandler) {
            buttonContainer.addEventListener('click', clickHandler);
        }

        return buttonContainer;
    };
});



// WEBPACK FOOTER //
// ./services/popupContentGenerator/actions/actionButton.js